import NotFound from "components/notFound/NotFound"

export default NotFound